<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h6 class="card-title mb-0">Entregas de Caja Chica</h6>
              <button v-if="isEditor('CajaChica')==true" class="btn btn-info btn-sm" @click="openApoderadoManagementModal">
                Gestionar Apoderados
              </button>
            </div>

            <form @submit.prevent="registrarEntrega" v-if="isEditor('CajaChica')==true">
              <div class="row g-3 align-items-end">
                <div class="col-md-6">
                  <label class="form-label">Seleccionar responsable</label>
                  <select
                    ref="selectPersona"
                    class="form-control js-personal-select"
                    v-model="nuevoMovimiento.legajo"
                    :disabled="cargandoPersonal"
                    @change="cargarGastosAprobados"
                  >
                    <option value="" disabled>
                      {{ cargandoPersonal ? 'Cargando nómina…' : '— Elegí un responsable —' }}
                    </option>
                    <option
                      v-for="persona in personalOptions"
                      :key="persona.leg_numero"
                      :value="persona.leg_numero"
                    >
                      {{ persona.leg_apellido.trim() }} {{ persona.leg_nombre.trim() }}
                      ({{ persona.leg_numdoc }})
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Monto a entregar</label>
                  <input
                    type="number"
                    min="1"
                    step="0.01"
                    class="form-control"
                    v-model.number="montoTotal"
                    placeholder="0.00"
                    readonly
                  />
                </div>
                <div class="col-md-2 d-grid">
                  <button  
                    class="btn btn-success"
                    type="submit"
                    :disabled="procesando || !gastosSeleccionados.length"
                  >
                    Registrar
                  </button>
                </div>
              </div>
            </form>
            <hr />
            <div v-if="gastosAprobados.length > 0" class="mb-4">
              <h6 class="mb-3">Gastos aprobados pendientes de pago</h6>
              
              <div class="mb-3">
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Buscar por legajo, empleado, detalle o monto..." 
                  v-model="filtroGastos"
                >
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Seleccionar</th>
                      <th>Legajo</th>
                      <th>Empleado</th>
                      <th>Detalle</th>
                      <th>Fecha</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="gasto in gastosAprobadosFiltrados" :key="gasto.fireId">
                      <td>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'gasto-' + gasto.fireId"
                            v-model="gasto.seleccionado"
                            @change="calcularTotal"
                          >
                        </div>
                      </td>
                      <td>{{ gasto.legajo }}</td>
                      <td>{{ gasto.nombre }}</td>
                      <td>{{ gasto.detalle }}</td>
                      <td>{{ gasto.desde }}</td>
                      <td>{{ gasto.gastos }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="gastosAprobadosFiltrados.length === 0" class="text-center text-muted p-2">
                  No se encontraron gastos con ese criterio.
                </div>
              </div>
            </div>
            <div v-else-if="nuevoMovimiento.legajo && !cargandoGastos">
              <div class="alert alert-info">
                No hay gastos aprobados pendientes de pago para este responsable.
              </div>
            </div>
            <div v-else-if="cargandoGastos">
              <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
              </div>
            </div>
            <hr />
            <div class="table-responsive">
              <table class="table table-striped align-middle" id="tablaCajaChica">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Receptor</th>
                    <th>Legajo</th>
                    <th>Monto</th>
                    <th>Entregado por</th>
                    <th>Nº Operación</th>
                    <th>% Completado</th>
                    <th>Estado</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="mov in movimientos" :key="mov.id">
                    <td>{{ mov.fecha }}</td>
                    <td>
                      {{ mov.receptor }}
                      <div v-if="mov.apoderadoNombre" class="text-muted small">
                        (Apoderado: {{ mov.apoderadoNombre }})
                      </div>
                    </td>
                    <td>{{ mov.legajo }}</td>
                    <td>$ {{ Number(mov.monto).toFixed(2) }}</td>
                    <td>{{ mov.entregado_por }}</td>
                    <td>{{ mov.operacion || '-' }}</td>
                    <td>
                      <div class="progress" style="height: 20px;">
                        <div
                          class="progress-bar bg-success"
                          role="progressbar"
                          :style="`width: ${mov.porcentajeCompletado || 0}%`"
                          :aria-valuenow="mov.porcentajeCompletado || 0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {{ mov.porcentajeCompletado || 0 }}%
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        v-if="mov.estado === 'esperando'"
                        class="badge bg-warning text-uppercase"
                      >
                        Esperando confirmación
                      </span>
                      <a
                        v-else
                        class="badge bg-success text-uppercase text-decoration-none"
                        style="cursor:pointer"
                        @click="abrirRecibo(mov)"
                        title="Ver PDF firmado"
                      >
                        Confirmado
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.min.css';
import Swal from 'sweetalert2';

// Las siguientes líneas de DataTables se asumen que ya están manejadas por tus `require` statements
// y que hacen que DataTables esté disponible globalmente en el objeto jQuery ($).
// require("datatables.net");
// require("datatables.net-buttons/js/buttons.colVis.js")();
// require("datatables.net-buttons/js/buttons.html5.js")();
// require("datatables.net-buttons/js/buttons.flash.js")();
// require("datatables.net-buttons/js/buttons.print.js")();
// require("../../../public/assets/css/data-table-estilos-propios.css");

/* ───────── Constantes de sesión ───────── */
const userData       = JSON.parse(sessionStorage.getItem('userData'));
const personalData   = JSON.parse(sessionStorage.getItem('personal'));
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));

export default {
  name: 'CajaChica',
  data() {
    return {
      personal: [],
      cargandoPersonal: true,
      movimientos: [],
      nuevoMovimiento: { legajo: '', monto: null },
      procesando: false,
      gastosAprobados: [],
      cargandoGastos: false,
      montoTotal: 0,
      personalData: {}, // Almacena { legajo: { nombre, dni } } para búsquedas rápidas
      pagosRecibidos: {}, // Caché para pagos recibidos
      apoderados: {}, // Almacena { legajo_principal: apoderado_legajo }
      currentUserLegajo: null, // Legajo del usuario actualmente logueado (aunque no se use para la lógica de apoderados en este caso, se mantiene)
      
      // AGREGADO: Variable para el filtro
      filtroGastos: '',
    };
  },
  computed: {
    personalFiltrado() {
      //return this.personal.filter(p => !p.leg_fecegr);
      return this.personal;
    },
    gastosSeleccionados() {
      return this.gastosAprobados.filter(gasto => gasto.seleccionado);
    },
    // AGREGADO: Computed property para filtrar
    gastosAprobadosFiltrados() {
      if (!this.filtroGastos) {
        return this.gastosAprobados;
      }
      const termino = this.filtroGastos.toLowerCase();
      
      return this.gastosAprobados.filter(gasto => {
        const legajoMatch = gasto.legajo && String(gasto.legajo).toLowerCase().includes(termino);
        const nombreMatch = gasto.nombre && gasto.nombre.toLowerCase().includes(termino);
        const detalleMatch = gasto.detalle && gasto.detalle.toLowerCase().includes(termino);
        const montoMatch = gasto.gastos && String(gasto.gastos).toLowerCase().includes(termino);

        return legajoMatch || nombreMatch || detalleMatch || montoMatch;
      });
    },
    personalOptions() {
      const options = [...this.personalFiltrado];
      const addedLegajos = new Set(options.map(p => p.leg_numero));

      // Si el usuario actual es apoderado de alguien, añadir a ese titular a las opciones
      // (Esta parte es para que el apoderado pueda verse a sí mismo y a sus titulares en el dropdown)
      if (this.currentUserLegajo) {
        for (const principalLegajo in this.apoderados) {
          // Usar == para comparación flexible si los tipos de legajo pueden variar (string/number)
          if (this.apoderados[principalLegajo] == this.currentUserLegajo) {
            const principal = this.personal.find(p => p.leg_numero == principalLegajo);
            if (principal && !addedLegajos.has(principal.leg_numero)) {
              options.push(principal);
              addedLegajos.add(principal.leg_numero);
            }
          }
        }
      }
      // Ordenar opciones por nombre para mejor UX
      return options.sort((a, b) => {
        const nameA = `${a.leg_apellido.trim()} ${a.leg_nombre.trim()}`;
        const nameB = `${b.leg_apellido.trim()} ${b.leg_nombre.trim()}`;
        return nameA.localeCompare(nameB);
      });
    }
  },
  methods: {


 isEditor(modulo){
      
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Editor;
            // console.log(modulo+' : '+status)
            return status;
          }else{
            console.log(modulo+' : '+false)
            return false;
          }
        },

    /*‑‑‑ Carga de personal ‑‑‑*/
    async cargarPersonal() {
      try {
        const res = await fetch(
          'https://auth.foodservice.com.ar/index_dev.php?type=personal&access_token=1234567'
        );
        this.personal = await res.json();

        // Crear un objeto para búsquedas rápidas por legajo
        this.personalData = {};
        this.personal.forEach(p => {
          this.personalData[p.leg_numero] = {
            nombre: `${p.leg_apellido.trim()} ${p.leg_nombre.trim()}`,
            dni: p.leg_numdoc
          };
        });
      } catch (err) {
        console.error('Error cargando personal:', err);
      } finally {
        this.cargandoPersonal = false;
        this.$nextTick(this.initSelect2);
      }
    },
    initSelect2() {
      const $sel = $(this.$refs.selectPersona);
      $sel.select2({ placeholder: 'Elegí un responsable', width: '100%' })
        .on('change', () => {
          this.nuevoMovimiento.legajo = $sel.val();
          console.log('Legajo seleccionado en el formulario:', this.nuevoMovimiento.legajo);
          this.cargarGastosAprobados();
        });
    },
    // Verificar si un gasto ya ha sido pagado
    async verificarPagoRecibido(legajo, fireId) {
      // Primero verificar en caché
      if (this.pagosRecibidos[legajo] && this.pagosRecibidos[legajo][fireId]) {
        return true;
      }

      // Si no está en caché, consultar Firebase
      try {
        const snap = await firebase.database()
          .ref(`pago_recibido/${legajo}/${fireId}`)
          .once('value');

        const data = snap.val();
        const pagado = data && data.recibido === true;

        // Guardar en caché (usando asignación directa para compatibilidad con Vue 3)
        if (!this.pagosRecibidos[legajo]) {
          this.pagosRecibidos[legajo] = {};
        }
        this.pagosRecibidos[legajo][fireId] = pagado;

        return pagado;
      } catch (err) {
        console.error('Error verificando pago recibido:', err);
        return false;
      }
    },
    /*‑‑‑ Carga de gastos aprobados para el responsable seleccionado ‑‑‑*/
    async cargarGastosAprobados() {
      // AGREGADO: Limpiar filtro al cambiar de responsable
      this.filtroGastos = '';

      console.log('--- cargarGastosAprobados START ---');
      console.log('nuevoMovimiento.legajo (selected in form):', this.nuevoMovimiento.legajo);
      console.log('apoderados (current state):', JSON.parse(JSON.stringify(this.apoderados))); // Deep copy for logging

      if (!this.nuevoMovimiento.legajo) {
        this.gastosAprobados = [];
        this.montoTotal = 0;
        console.log('No legajo selected, clearing expenses.');
        console.log('--- cargarGastosAprobados END ---');
        return;
      }

      this.cargandoGastos = true;
      this.gastosAprobados = [];
      this.montoTotal = 0;

      try {
        const selectedPersona = this.personal.find(p => p.leg_numero == this.nuevoMovimiento.legajo);
        if (!selectedPersona) {
          console.warn('Selected persona not found in personal list.');
          this.cargandoGastos = false;
          console.log('--- cargarGastosAprobados END ---');
          return;
        }
        console.log('Selected Persona (from dropdown):', selectedPersona.leg_apellido, selectedPersona.leg_nombre, 'DNI:', selectedPersona.leg_numdoc, 'Legajo:', selectedPersona.leg_numero);

        const dnisToFetch = new Set();
        dnisToFetch.add(selectedPersona.leg_numdoc); // DNI del responsable seleccionado en el formulario
        console.log(`Initially, DNI of selected person added: ${selectedPersona.leg_numdoc}`);

        // Check if the selected person is an apoderado for any titular
        for (const titularLegajo in this.apoderados) {
          const apoderadoLegajoForThisTitular = this.apoderados[titularLegajo];
          console.log(`Checking apoderado for titular ${titularLegajo}: apoderado is ${apoderadoLegajoForThisTitular}. Is it selected person (${selectedPersona.leg_numero})?`);

          if (apoderadoLegajoForThisTitular == selectedPersona.leg_numero) {
            const titular = this.personal.find(p => p.leg_numero == titularLegajo);
            if (titular) {
              dnisToFetch.add(titular.leg_numdoc);
              console.log(`YES! Selected person (${selectedPersona.leg_numero}) is apoderado for titular ${titular.leg_apellido} (Legajo: ${titular.leg_numero}, DNI: ${titular.leg_numdoc}). Adding titular's DNI to fetch list.`);
            } else {
              console.warn(`Titular with legajo ${titularLegajo} (apoderado by selected person) not found in personal list. Cannot add their DNI.`);
            }
          } else {
            console.log(`No, selected person (${selectedPersona.leg_numero}) is not apoderado for titular ${titularLegajo}.`);
          }
        }
        
        console.log('Final DNIs to fetch:', Array.from(dnisToFetch));

        await this.cargarPagosRecibidos(); // Asegurar que la caché de pagos esté cargada
        console.log('Pagos Recibidos Cache:', JSON.parse(JSON.stringify(this.pagosRecibidos)));

        let allGastos = [];
        for (const dni of dnisToFetch) { // Loop through all collected DNIs
          console.log(`--- Now fetching expenses for DNI: ${dni} ---`); // Added this log
          const snap = await firebase.database()
            .ref('novedades_usuarios_test_hrbp')
            .orderByChild('responsable_dni')
            .equalTo(dni)
            .once('value');

          const data = snap.val() || {};
          console.log(`Raw data for DNI ${dni}:`, data);

          const gastosPromises = Object.entries(data).map(async ([fireId, gasto]) => {
            if (gasto.status === 'Aprobado' && gasto.bejerman_id === 'B1982') {
              const pagado = await this.verificarPagoRecibido(gasto.legajo, fireId);
              console.log(`Expense ${fireId} (Legajo: ${gasto.legajo}, DNI: ${gasto.responsable_dni}) - Status: ${gasto.status}, Bejerman: ${gasto.bejerman_id}, Pagado: ${pagado}`);
              if (!pagado) {
                return {
                  fireId,
                  ...gasto,
                  seleccionado: false,
                  montoNumerico: this.extraerMonto(gasto.gastos)
                };
              }
            }
            return null;
          });
          const gastosResults = await Promise.all(gastosPromises);
          allGastos = allGastos.concat(gastosResults.filter(gasto => gasto !== null));
        }
        console.log('All fetched expenses (before unique filter):', JSON.parse(JSON.stringify(allGastos)));

        // Eliminar duplicados si un gasto aparece para múltiples DNIs (poco probable pero buena práctica)
        const uniqueGastos = [];
        const seenFireIds = new Set();
        for (const gasto of allGastos) {
          if (!seenFireIds.has(gasto.fireId)) {
            uniqueGastos.push(gasto);
            seenFireIds.add(gasto.fireId);
          }
        }
        this.gastosAprobados = uniqueGastos;

        console.log(`Final ${this.gastosAprobados.length} unique pending expenses:`, JSON.parse(JSON.stringify(this.gastosAprobados)));
        console.log('--- cargarGastosAprobados END ---');
      } catch (err) {
        console.error('Error cargando gastos aprobados:', err);
        Swal.fire('Error', 'No se pudieron cargar los gastos aprobados.', 'error');
      } finally {
        this.cargandoGastos = false;
      }
    },
    // Cargar todos los pagos recibidos para tener una caché
    async cargarPagosRecibidos() {
      try {
        const snap = await firebase.database()
          .ref('pago_recibido')
          .once('value');

        const data = snap.val() || {};

        // Estructurar los datos para fácil acceso (usando asignación directa para compatibilidad con Vue 3)
        this.pagosRecibidos = {};

        Object.entries(data).forEach(([legajo, pagos]) => {
          this.pagosRecibidos[legajo] = {};
          Object.entries(pagos).forEach(([fireId, info]) => {
            this.pagosRecibidos[legajo][fireId] = info.recibido === true;
          });
        });

        console.log('Caché de pagos recibidos cargada');
      } catch (err) {
        console.error('Error cargando pagos recibidos:', err);
      }
    },
    // Extraer valor numérico del formato "$1,234.56" o "1234.56"
    extraerMonto(montoStr) {
      if (!montoStr) return 0;

      // Si es un string, eliminar el símbolo $ y cualquier separador de miles
      if (typeof montoStr === 'string') {
        // Reemplazar comas por puntos si hay más de un punto (formato argentino)
        if ((montoStr.match(/\./g) || []).length > 1) {
          montoStr = montoStr.replace(/\./g, '').replace(',', '.');
        } else {
          montoStr = montoStr.replace(/[$,]/g, '');
        }
        return parseFloat(montoStr) || 0;
      }

      // Si ya es un número, devolverlo directamente
      return parseFloat(montoStr) || 0;
    },
    // Calcular el total de los gastos seleccionados
    calcularTotal() {
      this.montoTotal = this.gastosSeleccionados.reduce(
        (total, gasto) => total + gasto.montoNumerico,
        0
      );
    },
    /*‑‑‑ Carga de movimientos ‑‑‑*/
    async cargarMovimientos() {
      const snap = await firebase.database().ref('caja_chica').once('value');
      const data = snap.val() || {};
      const movimientosRaw = Object.entries(data)
        .map(([id, val]) => ({ id, ...val }))
        .sort((a, b) => b.id - a.id);

      // Obtener nombres de apoderados para cada movimiento
      const movimientosWithApoderados = await Promise.all(movimientosRaw.map(async mov => {
        const apoderadoLegajo = this.apoderados[mov.legajo];
        let apoderadoNombre = null;
        if (apoderadoLegajo) {
          const apoderado = this.personal.find(p => p.leg_numero == apoderadoLegajo);
          if (apoderado) {
            apoderadoNombre = `${apoderado.leg_apellido.trim()} ${apoderado.leg_nombre.trim()}`;
          }
        }
        // Usar asignación directa para compatibilidad con Vue 3
        mov.apoderadoLegajo = apoderadoLegajo;
        mov.apoderadoNombre = apoderadoNombre;
        return mov;
      }));

      this.movimientos = movimientosWithApoderados;
      this.$nextTick(this.initDataTable); // Re-inicializar DataTable después de cargar los datos
    },
    /*‑‑‑ Carga de apoderados ‑‑‑*/
    async cargarApoderados() {
      try {
        const snap = await firebase.database().ref('apoderados').once('value');
        this.apoderados = snap.val() || {};
        console.log('Apoderados cargados:', this.apoderados);
      } catch (err) {
        console.error('Error cargando apoderados:', err);
      }
    },
    /*‑‑‑ Abrir modal de Gestión de Apoderados ‑‑‑*/
    async openApoderadoManagementModal() {
      let titularSelect2Instance = null;
      let apoderadoSelect2Instance = null;

      await Swal.fire({
        title: 'Gestión de Apoderados',
        html: `
          <div class="mb-4">
            <h5 class="mb-3">Asignar Nuevo Apoderado</h5>
            <div class="form-group mb-3">
              <label for="swal-titular-select" class="form-label">Seleccionar Titular</label>
              <select id="swal-titular-select" class="form-control"></select>
            </div>
            <div class="form-group mb-3">
              <label for="swal-apoderado-select" class="form-label">Seleccionar Apoderado</label>
              <select id="swal-apoderado-select" class="form-control"></select>
            </div>
            <div id="swal-assign-button-container" class="mt-3 text-center"></div>
          </div>

          <hr class="my-4">

          <div class="mb-4">
            <h5 class="mb-3">Apoderados Existentes</h5>
            <div id="existing-apoderados-list" class="list-group">
              </div>
            <div v-if="Object.keys(apoderados).length === 0" class="alert alert-info mt-3">
              No hay apoderados asignados.
            </div>
          </div>
        `,
        showCancelButton: true,
        showConfirmButton: false, // Hide default SweetAlert confirm button
        didOpen: () => {
          const $titularSelect = $('#swal-titular-select');
          const $apoderadoSelect = $('#swal-apoderado-select');
          const $assignButtonContainer = $('#swal-assign-button-container');
          const $existingApoderadosList = $('#existing-apoderados-list');

          // Inicializar Select2 para Titular
          titularSelect2Instance = $titularSelect.select2({
            dropdownParent: $('.swal2-container'),
            placeholder: 'Buscar titular...',
            width: '100%',
            data: this.personalFiltrado.map(p => ({
              id: p.leg_numero,
              text: `${p.leg_apellido.trim()} ${p.leg_nombre.trim()} (${p.leg_numdoc})`
            }))
          });

          // Inicializar Select2 para Apoderado
          apoderadoSelect2Instance = $apoderadoSelect.select2({
            dropdownParent: $('.swal2-container'),
            placeholder: 'Buscar apoderado...',
            width: '100%',
            data: this.personalFiltrado.map(p => ({
              id: p.leg_numero,
              text: `${p.leg_apellido.trim()} ${p.leg_nombre.trim()} (${p.leg_numdoc})`
            }))
          });

          // Create and append the Assign button
          const assignButton = document.createElement('button');
          assignButton.className = 'btn btn-primary';
          assignButton.textContent = 'Asignar Apoderado';
          assignButton.onclick = async () => {
            const titularLegajo = $titularSelect.val();
            const apoderadoLegajo = $apoderadoSelect.val();

            if (!titularLegajo) {
              Swal.showValidationMessage('Debe seleccionar un titular.');
              return;
            }
            if (!apoderadoLegajo) {
              Swal.showValidationMessage('Debe seleccionar un apoderado.');
              return;
            }
            if (titularLegajo == apoderadoLegajo) {
              Swal.showValidationMessage('Un titular no puede ser su propio apoderado.');
              return;
            }

            await this.performAssignApoderado(titularLegajo, apoderadoLegajo);
            this.renderExistingApoderadosList($existingApoderadosList); // Re-render the list
            $titularSelect.val(null).trigger('change'); // Clear selections
            $apoderadoSelect.val(null).trigger('change');
          };
          $assignButtonContainer.append(assignButton);

          // Render the initial list of existing apoderados
          this.renderExistingApoderadosList($existingApoderadosList);
        },
        willClose: () => {
          // Destruir las instancias de Select2 para evitar fugas de memoria
          if (titularSelect2Instance) {
            titularSelect2Instance.select2('destroy');
          }
          if (apoderadoSelect2Instance) {
            apoderadoSelect2Instance.select2('destroy');
          }
        }
      });
    },
    /*‑‑‑ Helper para renderizar la lista de apoderados existentes en el modal ‑‑‑*/
    renderExistingApoderadosList($container) {
      $container.empty(); // Clear previous list

      const apoderadosArray = Object.entries(this.apoderados).map(([titularLegajo, apoderadoLegajo]) => {
        const titular = this.personal.find(p => p.leg_numero == titularLegajo);
        const apoderado = this.personal.find(p => p.leg_numero == apoderadoLegajo);
        return {
          titularLegajo,
          apoderadoLegajo,
          titularNombre: titular ? `${titular.leg_apellido.trim()} ${titular.leg_nombre.trim()}` : `Legajo ${titularLegajo} (No encontrado)`,
          apoderadoNombre: apoderado ? `${apoderado.leg_apellido.trim()} ${apoderado.leg_nombre.trim()}` : `Legajo ${apoderadoLegajo} (No encontrado)`
        };
      }).sort((a, b) => a.titularNombre.localeCompare(b.titularNombre)); // Sort for better UX

      if (apoderadosArray.length === 0) {
        // This message is now handled by the v-if in the template
        // $container.html('<div class="alert alert-info mt-3">No hay apoderados asignados.</div>');
        return;
      }

      apoderadosArray.forEach(assignment => {
        const listItem = document.createElement('div');
        listItem.className = 'list-group-item d-flex justify-content-between align-items-center';
        listItem.innerHTML = `
          <div>
            <b>${assignment.titularNombre}</b>
            <br>
            <small class="text-muted">Apoderado: ${assignment.apoderadoNombre}</small>
          </div>
        `;

        const removeButton = document.createElement('button');
        removeButton.className = 'btn btn-danger btn-sm';
        removeButton.textContent = 'Quitar';
        removeButton.onclick = async () => {
          await this.performRemoveApoderado(assignment.titularLegajo);
          this.renderExistingApoderadosList($container); // Re-render the list after removal
        };
        listItem.append(removeButton);
        $container.append(listItem);
      });
    },
    /*‑‑‑ Lógica para Asignar Apoderado (llamada desde el modal) ‑‑‑*/
    async performAssignApoderado(titularLegajo, apoderadoLegajo) {
      const titular = this.personal.find(p => p.leg_numero == titularLegajo);
      const apoderado = this.personal.find(p => p.leg_numero == apoderadoLegajo);

      if (!titular || !apoderado) {
        Swal.fire('Error', 'Titular o apoderado no encontrado.', 'error');
        return;
      }

      const confirma = await Swal.fire({
        title: 'Confirmar Asignación',
        html: `¿Desea asignar a <b>${apoderado.leg_apellido.trim()} ${apoderado.leg_nombre.trim()}</b> como apoderado de <b>${titular.leg_apellido.trim()} ${titular.leg_nombre.trim()}</b>?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, asignar',
        cancelButtonText: 'Cancelar',
      });

      if (confirma.isConfirmed) {
        try {
          await firebase.database().ref(`apoderados/${titularLegajo}`).set(apoderadoLegajo);
          this.apoderados[titularLegajo] = apoderadoLegajo; // Actualizar estado local
          Swal.fire('Asignado', 'Apoderado asignado correctamente.', 'success');
        } catch (e) {
          console.error('Error asignando apoderado:', e);
          Swal.fire('Error', 'No se pudo asignar el apoderado.', 'error');
        }
      }
    },
    /*‑‑‑ Lógica para Quitar Apoderado (llamada desde el modal) ‑‑‑*/
    async performRemoveApoderado(titularLegajo) {
      const titular = this.personal.find(p => p.leg_numero == titularLegajo);
      if (!titular) {
        Swal.fire('Error', 'Titular no encontrado.', 'error');
        return;
      }

      const confirma = await Swal.fire({
        title: 'Confirmar Eliminación',
        html: `¿Desea quitar el apoderado de <b>${titular.leg_apellido.trim()} ${titular.leg_nombre.trim()}</b>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, quitar',
        cancelButtonText: 'Cancelar',
      });

      if (confirma.isConfirmed) {
        try {
          await firebase.database().ref(`apoderados/${titularLegajo}`).remove();
          delete this.apoderados[titularLegajo]; // Actualizar estado local
          Swal.fire('Quitado', 'Apoderado quitado correctamente.', 'success');
        } catch (e) {
          console.error('Error quitando apoderado:', e);
          Swal.fire('Error', 'No se pudo quitar el apoderado.', 'error');
        }
      }
    },
    /*‑‑‑ Abrir PDF firmado (solo cuando estado === 'confirmado') ‑‑‑*/
    abrirRecibo(mov) {
      const url = `https://servicio.foodservice.com.ar/core/signa/firmados_gastos/recibo_${mov.legajo}_${mov.id}.pdf`;
      window.open(url, '_blank');
    },
    /*‑‑‑ Registrar entrega (monto se almacena sin separadores) ‑‑‑*/
    async registrarEntrega() {
      if (!this.gastosSeleccionados.length) {
        Swal.fire('Atención', 'Debe seleccionar al menos un gasto para registrar la entrega.', 'warning');
        return;
      }
      const persona = this.personal.find(p => p.leg_numero == this.nuevoMovimiento.legajo);
      if (!persona) return;
      // Solicitar número de operación
      const { value: numeroOperacion, isConfirmed } = await Swal.fire({
        title: 'Número de operación',
        input: 'text',
        inputLabel: 'Ingrese el número de operación para este pago',
        inputPlaceholder: 'Ej: OP-12345',
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'Debe ingresar un número de operación';
          }
        }
      });

      if (!isConfirmed) return;
      // Confirmar la entrega
      const confirma = await Swal.fire({
        title: 'Confirmar entrega',
        html: `¿Desea confirmar la entrega de <b>$${this.montoTotal.toFixed(2)}</b> pesos a <b>${persona.leg_apellido.trim()} ${persona.leg_nombre.trim()}</b>?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, entregar',
        cancelButtonText: 'Cancelar',
      });

      if (!confirma.isConfirmed) return;
      this.procesando = true;
      const fechaObj = new Date();
      const fecha = fechaObj.toLocaleDateString('es-AR') + ' ' + fechaObj.toLocaleTimeString('es-AR');
      const user = JSON.parse(sessionStorage.getItem('userData')) || {};
      try {
        // Crear el ID para el nuevo movimiento
        const id = Date.now();

        // Preparar los detalles de los gastos seleccionados
        const gastosDetalles = this.gastosSeleccionados.map(gasto => ({
          fireId: gasto.fireId,
          legajo: gasto.legajo,
          nombre: gasto.nombre,
          monto: gasto.montoNumerico,
          detalle: gasto.detalle,
          desde: gasto.desde
        }));

        // Total de personas afectadas por este pago
        const totalPersonas = new Set(gastosDetalles.map(g => g.legajo)).size;

        // Crear el nuevo movimiento
        const nuevo = {
          legajo: persona.leg_numero,
          receptor: `${persona.leg_apellido.trim()} ${persona.leg_nombre.trim()}`,
          monto: this.montoTotal.toFixed(2),
          entregado_por: `${user.leg_nombre} ${user.leg_apellido}`,
          fecha,
          estado: 'esperando',
          operacion: numeroOperacion,
          gastos: gastosDetalles,
          totalPersonas,
          personasPagadas: 0,
          porcentajeCompletado: 0
        };
        // Guardar el movimiento en Firebase
        await firebase.database().ref('caja_chica/' + id).set(nuevo);

        // Marcar los gastos como pagados en Firebase (ahora en novedades_usuarios_test_hrbp)
        const updates = {};
        for (const gasto of this.gastosSeleccionados) {
          updates[`novedades_usuarios_test_hrbp/${gasto.fireId}/pagado`] = true;
          updates[`novedades_usuarios_test_hrbp/${gasto.fireId}/operacion`] = numeroOperacion;
          updates[`novedades_usuarios_test_hrbp/${gasto.fireId}/fecha_pago`] = fecha;
        }

        await firebase.database().ref().update(updates);

        // Actualizar la interfaz
        // Destruir y re-inicializar DataTable
        if ($.fn.DataTable.isDataTable('#tablaCajaChica')) {
          $('#tablaCajaChica').DataTable().destroy();
        }
        this.movimientos.unshift({ id, ...nuevo });
        this.nuevoMovimiento = { legajo: '', monto: null };
        this.gastosAprobados = [];
        this.montoTotal = 0;
        $(this.$refs.selectPersona).val('').trigger('change');
        this.$nextTick(this.initDataTable); // Re-inicializar DataTable

        Swal.fire('Registrado', 'Entrega guardada correctamente.', 'success');
      } catch (e) {
        console.error('Error guardando movimiento:', e);
        Swal.fire('Error', 'No se pudo guardar la entrega.', 'error');
      } finally {
        this.procesando = false;
      }
    },
    // Actualizar el porcentaje de personas que han recibido su pago
    async actualizarPorcentajeCompletado(movimientoId) {
      try {
        const snap = await firebase.database()
          .ref('caja_chica')
          .child(movimientoId)
          .once('value');

        const movimiento = snap.val();
        if (!movimiento || !movimiento.gastos) return;

        // Contar cuántas personas distintas han confirmado recepción
        const personasConfirmadas = new Set();
        let totalPersonas = new Set();

        for (const gasto of movimiento.gastos) {
          totalPersonas.add(gasto.legajo);

          // Verificar si esta persona ha confirmado recepción
          const confirmacionSnap = await firebase.database()
            .ref(`pago_recibido/${gasto.legajo}/${gasto.fireId}`)
            .once('value');

          const confirmacion = confirmacionSnap.val();
          if (confirmacion && confirmacion.recibido === true) {
            personasConfirmadas.add(gasto.legajo);
          }
        }

        // Calcular porcentaje
        const porcentaje = Math.round((personasConfirmadas.size / totalPersonas.size) * 100);

        // Actualizar en Firebase
        await firebase.database().ref('caja_chica/' + movimientoId).update({
          personasPagadas: personasConfirmadas.size,
          porcentajeCompletado: porcentaje
        });

        // Actualizar en la interfaz (usando asignación directa para compatibilidad con Vue 3)
        const movIndex = this.movimientos.findIndex(m => m.id === movimientoId);
        if (movIndex >= 0) {
          this.movimientos[movIndex].personasPagadas = personasConfirmadas.size;
          this.movimientos[movIndex].porcentajeCompletado = porcentaje;
          // Redibujar la fila en DataTable si es necesario
          if ($.fn.DataTable.isDataTable('#tablaCajaChica')) {
            const dataTable = $('#tablaCajaChica').DataTable();
            // Encuentra la fila por el ID del movimiento
            const row = dataTable.rows().eq(0).filter(function (rowIdx) {
                return dataTable.row(rowIdx).data().id === movimientoId;
            });
            if (row.length) {
              // Actualiza los datos de la fila y redibuja
              dataTable.row(row).data(this.movimientos[movIndex]).draw();
            }
          }
        }
      } catch (err) {
        console.error('Error actualizando porcentaje completado:', err);
      }
    },
    initDataTable() {
      if ($.fn.DataTable.isDataTable('#tablaCajaChica')) {
        $('#tablaCajaChica').DataTable().destroy();
      }
      this.$nextTick(() => {
        $('#tablaCajaChica').DataTable({
          language:{decimal:',',thousands:'.',info:'Mostrando _START_-_END_ de _TOTAL_',infoEmpty:'0-0 de 0',infoFiltered:'(filtrado de _MAX_)',loadingRecords:'Cargando…',lengthMenu:'Mostrar _MENU_',paginate:{first:'Primero',last:'Último',next:'Siguiente',previous:'Anterior'},processing:'Procesando…',search:'Buscar:',zeroRecords:'No hay resultados',emptyTable:'Sin datos',aria:{sortAscending:'Orden asc',sortDescending:'Orden desc'}},
        scrollX:false,
        dom:'Bfrtip',
        buttons:[
          'copy','excel','csv',
        
        ],
          // Asegurar que DataTables maneje la nueva columna
          columns: [
            null, // Fecha
            null, // Receptor
            null, // Legajo
            null, // Monto
            null, // Entregado por
            null, // Nº Operación
            null, // % Completado
            null, // Estado
            // La columna de acciones ya no está en el HTML, así que no se define aquí
          ]
        });
      });
    },
    getCurrentUserLegajo() {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (userData && userData.leg_numero) {
        this.currentUserLegajo = userData.leg_numero;
      }
      console.log('Current User Legajo:', this.currentUserLegajo);
    }
  },
  async mounted() {
    this.getCurrentUserLegajo(); // Obtener el legajo del usuario actual primero
    await Promise.all([this.cargarPersonal(), this.cargarApoderados()]);
    await this.cargarMovimientos(); // Esto ahora usará los datos de apoderados e inicializará DataTable

    // Configurar listener para actualizaciones de pagos recibidos
    firebase.database().ref('pago_recibido').on('child_added', snapshot => {
      // Cuando se recibe un nuevo pago, actualizar los porcentajes
      this.movimientos.forEach(mov => {
        if (mov.gastos && mov.gastos.some(g => g.legajo == snapshot.key)) {
          this.actualizarPorcentajeCompletado(mov.id);
        }
      });
    });

    firebase.database().ref('pago_recibido').on('child_changed', snapshot => {
      // Cuando se actualiza un pago, actualizar los porcentajes
      this.movimientos.forEach(mov => {
        if (mov.gastos && mov.gastos.some(g => g.legajo == snapshot.key)) {
          this.actualizarPorcentajeCompletado(mov.id);
        }
      });
    });

    // Listener para cambios en apoderados para actualizar la tabla de movimientos
    firebase.database().ref('apoderados').on('value', snapshot => {
      this.apoderados = snapshot.val() || {};
      console.log('Apoderados updated via listener:', JSON.parse(JSON.stringify(this.apoderados)));
      this.cargarMovimientos(); // Re-cargar movimientos para reflejar cambios de apoderados
      // También recargar gastos aprobados si hay un responsable seleccionado
      if (this.nuevoMovimiento.legajo) {
        this.cargarGastosAprobados();
      }
    });
  },
  beforeUnmount() {
    firebase.database().ref('pago_recibido').off();
    firebase.database().ref('apoderados').off(); // Desactivar listener de apoderados
    if ($.fn.DataTable.isDataTable('#tablaCajaChica')) {
      $('#tablaCajaChica').DataTable().destroy();
    }
  }
};
</script>

<style scoped>
/* Estética básica para Select2 sin Bootstrap */
.select2-container .select2-selection {
  min-height: 38px;
  padding: 6px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  cursor: pointer;
}
.select2-container--focus .select2-selection {
  border-color: #25d366;
  box-shadow: 0 0 0 0.2rem rgba(37, 211, 102, 0.25);
}
.select2-selection__rendered {
  line-height: 24px;
}
.select2-selection__arrow {
  height: 36px !important;
  right: 6px;
}
.select2-container .select2-selection--single {
  height: 35px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #444;
  line-height: 18px;
}
.select2-results__option--highlighted {
  background: #25d366 !important;
  color: #fff;
}
.form-check {
  position: relative;
  margin-top: -10px;
  margin-bottom: 10px;
  padding-left: 47px;
}
/* Los estilos de DataTables se asumen que vienen de tu archivo data-table-estilos-propios.css */
</style>